<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2026-06-23 17:32:45
 * @LastEditors: hl
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/purchase/index.vue
-->
<template>
  <div class="purchase_con">
    <title-bar-back :title="'确认订单'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <!-- 头部信息 -->
    <!-- 非鲜奶卡 -->
    <div v-if="preCheckout.orderType !== 2">
      <!-- 配送服务选择一栏（仅全球购项目且 logisticsTypeList 非空时展示，包含警告横幅） -->
      <logistics-select
        v-if="
          $appSource === 3 &&
            preCheckout.logisticsTypeList &&
            preCheckout.logisticsTypeList.length > 0
        "
        :logisticsType="logisticsType"
        :logisticsTypeList="preCheckout.logisticsTypeList"
        :isAllow="preCheckout.isAllow"
        :addressConstant="preCheckout.addressConstant"
        :selectImg="selectImg"
        :unSelectImg="unSelectImg"
        @change="changeLogisticsType"
      />

      <!-- 自提门店展示 -->
      <pickup-address-card
        v-if="$appSource === 3 && logisticsType === 0"
        :pickupAddress="preCheckout.pickupAddress"
        @contactService="contactService"
      />

      <!-- 邮寄收货地址 -->
      <pur-address
        v-if="
          ($appSource !== 3 || logisticsType !== 0) &&
            preCheckout.orderType !== 2
        "
        :isAllow="preCheckout.isAllow"
        :addressConstant="preCheckout.addressConstant"
        :address="address"
        @goAddressList="goAddressList"
      />
      <!-- 商品信息 -->
      <div class="product_con_det">
        <shop-header
          @goExplain="goExplain"
          :switchOrderType="preCheckout.orderType"
          :storeName="preCheckout.storeName"
        />
        <div v-for="(item, index2) in preCheckout.itemList" :key="index2">
          <!-- 商品信息 -->
          <order-product-list
            :listIndex="index2"
            :pageShow="false"
            :item="item"
            class="pro_padd"
          />
          <!-- 赠品 -->
          <div
            v-if="item.giftList && item.giftList.length"
            class="free_product_list"
          >
            <free-product
              v-for="(item, index) in item.giftList"
              :key="index"
              :showLine="false"
              :freeProduct="item"
              :class="{ border_top1px: index === 0 }"
              class="free_pad"
            />
          </div>
        </div>
      </div>
      <!-- 鲜奶时间 -->
      <milk-date
        v-if="preCheckout.orderType === 1"
        @goChooseDate="goChooseDate"
        :item="preCheckout"
      />
    </div>
    <!-- 鲜奶卡 -->
    <div v-if="preCheckout.orderType === 2">
      <shop-header
        :switchOrderType="preCheckout.orderType"
        :storeName="preCheckout.storeName"
        :showExp="false"
      />
      <milk-card />
      <!-- 赠品 -->
      <div
        v-if="
          preCheckout.itemList[0].giftList &&
            preCheckout.itemList[0].giftList.length
        "
        class="free_product_list"
      >
        <free-product
          v-for="(item, index) in preCheckout.itemList[0].giftList"
          :key="index"
          :showLine="false"
          :freeProduct="item"
          :class="{ border_top1px: index === 0 }"
          class="free_pad"
        />
      </div>
    </div>

    <!-- 订单价格与配送留言一体化卡片 -->
    <order-price
      :note="note"
      @goNote="goNote"
      @openServicePopup="openServicePopup"
    />

    <!-- 支付方式选择一栏（仅全球购且有支付列表时显示） -->
    <pay-mode-select
      v-if="
        $appSource === 3 &&
          preCheckout.payModeList &&
          preCheckout.payModeList.length > 0
      "
      :payType="payType"
      :payModeList="preCheckout.payModeList"
      :selectImg="selectImg"
      :unSelectImg="unSelectImg"
      @change="changePayType"
    />

    <!-- 协议 -->
    <div
      class="font12 font_weight400 colo037 line_height_17 det_all"
      @click="goOrder1"
    >
      <span>确认支付即表示同意</span>
      <span class="det_color">《消费者告知书》</span>
    </div>
    <div class="bottom_margin"></div>
    <!-- 底部按钮 -->
    <pur-btn @submitBtn="submitBtn" />
    <!-- 实名认证 -->
    <id-num-action-sheet
      v-if="showIdSheet"
      @closeSheet="closeSheet"
      @sure="sure"
      @inputName="inputName"
      @inputId="inputId"
    />
    <!-- 运费异常/区域限制弹窗 -->
    <van-popup
      v-model="showFreightPopup"
      position="bottom"
      round
      :style="{ height: '60%' }"
    >
      <div class="freight_popup">
        <div class="freight_header">
          <span class="freight_title">{{
            preCheckout.freightError ? "下单区域限制" : "运费详情"
          }}</span>
          <img
            src="@/assets/mine/icon_close@2x.png"
            class="close_icon"
            @click="showFreightPopup = false"
          />
        </div>
        <div v-if="preCheckout.freightError" class="warning_bar">
          以下商品暂无法配送至当前地址，请进行调整
        </div>
        <div class="freight_list">
          <div
            v-for="(item, index) in preCheckout.freightErrorDetailList"
            :key="index"
            class="freight_cell"
          >
            <div class="cell_header">
              <span class="store_name">{{ item.popStoreName }}</span>
              <span class="price_info">
                小计：{{ $G("symbol") }}{{ item.popStorePrice }} / 运费：{{
                  $G("symbol")
                }}{{ item.popStoreFreightAmount }}
              </span>
            </div>
            <div class="cell_divider"></div>
            <div class="goods_grid">
              <div
                v-for="(sku, idx) in item.skuList"
                :key="idx"
                class="goods_img_box"
              >
                <img :src="sku.skuUrl" class="goods_img" />
              </div>
            </div>
          </div>
        </div>
        <div class="freight_btn_container">
          <div class="sure_btn" @click="showFreightPopup = false">确定</div>
        </div>
      </div>
    </van-popup>
    <!-- 增值服务多选弹窗 -->
    <van-popup
      v-model="showServicePopup"
      position="bottom"
      round
      closeable
      :style="{ height: '60%' }"
    >
      <div class="service_popup_box">
        <div class="service_popup_title">选择增值服务</div>
        <div class="service_popup_content">
          <div class="service_tags_container">
            <div
              v-for="(item, index) in preCheckout.valueAddedServices"
              :key="item.id"
              :class="{
                service_tag_selected: tempSelectedServiceIds.includes(item.id)
              }"
              class="service_tag"
              @click="toggleServiceTag(item, index)"
            >
              + {{ item.description || item.name }}
            </div>
          </div>
        </div>
        <div class="service_popup_footer">
          <div class="confirm_btn" @click="confirmSelectedServices">确定</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import PurAddress from "./components/PurAddress";
import ShopHeader from "./components/ShopHeader";
import OrderProductList from "../list/components/OrderProductList";
import FreeProduct from "../../cart/components/FreeProduct";
import OrderPrice from "./components/OrderPrice";
import PurBtn from "./components/PurBtn";
import MilkDate from "./components/MilkDate";
import IdNumActionSheet from "./components/IdNumActionSheet";
import MilkCard from "./components/MilkCard";
import LogisticsSelect from "./components/LogisticsSelect";
import PickupAddressCard from "./components/PickupAddressCard";
import PayModeSelect from "./components/PayModeSelect";

export default {
  name: "Purchase",
  components: {
    TitleBarBack,
    PurAddress,
    ShopHeader,
    OrderProductList,
    FreeProduct,
    OrderPrice,
    PurBtn,
    MilkDate,
    IdNumActionSheet,
    MilkCard,
    LogisticsSelect,
    PickupAddressCard,
    PayModeSelect
  },
  data() {
    return {
      showIdSheet: false,
      showFreightPopup: false,
      idList: [],
      idName: "",
      idCard: "",
      address: {},
      logisticsType: null, // 配送模式 0:自提, 1:配送, 2:直邮
      payType: null, // 支付类型 1:线上支付, 2:货到付款
      selectImg: require("@/assets/login/select@2x.png"),
      unSelectImg: require("@/assets/login/unselect_icon@2x.png"),
      showServicePopup: false,
      selectedServiceIds: [],
      tempSelectedServiceIds: [],
      note: localStorage.getItem("pur-note") || ""
    };
  },
  watch: {
    address() {
      // console.log(this.address, "1111watch");
    },
    $route(to) {
      if (to.path === "/order/purchase") {
        this.note = localStorage.getItem("pur-note") || "";
      }
    }
  },
  computed: {
    preCheckout() {
      return this.$store.getters.preCheckout;
    }
  },
  created() {
    if (this.$appSource === 3) {
      const cachedLogisticsType = sessionStorage.getItem("pur-logisticsType");
      if (cachedLogisticsType !== null) {
        this.logisticsType = parseInt(cachedLogisticsType);
      }
      const cachedPayType = sessionStorage.getItem("pur-payType");
      if (cachedPayType !== null) {
        this.payType = parseInt(cachedPayType);
      }
    }
    this.getData();
  },
  methods: {
    back() {
      this.$router.back();
      localStorage.removeItem("pur-note");
      localStorage.removeItem("pur-address");
      localStorage.removeItem("mall-wap-pur-choosedate");
      sessionStorage.removeItem("pur-logisticsType");
      sessionStorage.removeItem("pur-payType");
    },
    // 获取预下单请求参数
    getPreCheckoutParams() {
      let params = {};
      if (parseInt(this.$route.query.buyNow) !== 1) {
        // 购物车
        params = {
          idList: JSON.parse(this.$route.query.idList),
          buyNow: parseInt(this.$route.query.buyNow),
          slug: this.slug
        };
      } else {
        // 商详
        const buyFreeId =
          this.$route.query.buyFreeId ||
          (this.preCheckout &&
            this.preCheckout.itemList &&
            this.preCheckout.itemList[0] &&
            this.preCheckout.itemList[0].buyFreeId) ||
          "";

        let giftCarts = [];
        if (this.$route.query.giftCarts) {
          try {
            giftCarts =
              typeof this.$route.query.giftCarts === "string"
                ? JSON.parse(this.$route.query.giftCarts)
                : this.$route.query.giftCarts;
          } catch (e) {
            giftCarts = [];
          }
        }

        const item = {
          spuId: this.$route.query.spuId,
          skuId: this.$route.query.skuId,
          amount: this.$route.query.amount
        };

        if (giftCarts && giftCarts.length > 0) {
          item.giftCarts = giftCarts;
        }

        if (buyFreeId) {
          item.buyFreeId = buyFreeId;
        }

        params = {
          item,
          buyNow: parseInt(this.$route.query.buyNow),
          slug: this.slug
        };
      }

      // 携带配送模式与支付方式至预下单接口中
      if (this.$appSource === 3) {
        if (this.logisticsType !== null) {
          params.deliveryMode = this.logisticsType;
        }
        if (this.payType !== null) {
          params.payType = this.payType;
        }
        if (this.selectedServiceIds && this.selectedServiceIds.length > 0) {
          params.selectedServiceIds = this.selectedServiceIds;
        }
      }

      // 配送地址 ID 处理（自提模式不传入收件地址 ID）
      if (this.$appSource === 3 && this.logisticsType === 0) {
        params.addressId = "";
      } else {
        params.addressId = localStorage.getItem("pur-address")
          ? JSON.parse(localStorage.getItem("pur-address")).id
          : this.address && this.address.id
          ? this.address.id
          : "";
      }

      return params;
    },
    syncAddress(res) {
      if (
        res.address &&
        res.address !== null &&
        Object.keys(res.address).length > 0
      ) {
        this.address = JSON.parse(JSON.stringify(res.address));
      } else if (localStorage.getItem("pur-address")) {
        this.address = JSON.parse(localStorage.getItem("pur-address"));
      } else {
        this.address = {};
      }
    },
    getData() {
      const params = this.getPreCheckoutParams();
      this.$store
        .dispatch("cart/preCheckout", { params })
        .then(res => {
          this.idName = res.idcardName;
          this.idCard = res.idcardNo;

          // 全球购下的配送模式与支付初始化
          if (this.$appSource === 3) {
            this.initLogisticsAndPay(res);
            if (res && res.valueAddedServices) {
              this.selectedServiceIds = res.valueAddedServices
                .filter(e => e.selected)
                .map(e => e.id);
            }
          }

          this.syncAddress(res);
        })
        .catch(() => {});
    },
    initLogisticsAndPay(res) {
      // 1. 初始化及校准配送模式 logisticsType
      let logisticsType = this.logisticsType;
      let logisticsList = res.logisticsTypeList || [];
      if (logisticsType === null || !logisticsList.includes(logisticsType)) {
        logisticsType =
          res.deliveryMode !== undefined ? res.deliveryMode : null;
        if (logisticsType === null && logisticsList.length > 0) {
          logisticsType = logisticsList[0];
        }
      }
      this.logisticsType = logisticsType;
      if (logisticsType !== null) {
        sessionStorage.setItem("pur-logisticsType", logisticsType);
      }

      // 2. 初始化及支付方式 payType
      let payType = this.payType;
      let payList = res.payModeList || [];
      if (payType === null || !payList.includes(payType)) {
        payType = res.payType !== undefined ? res.payType : 1;
        if (payList.length > 0 && !payList.includes(payType)) {
          payType = payList[0];
        }
      }
      this.payType = payType;
      sessionStorage.setItem("pur-payType", payType);

      // 3. 计算并同步更新 Vuex 中 preCheckout 结构下的运费与总金额
      this.updateVuexPrice(res);
    },
    updateVuexPrice(res) {
      if (this.$appSource !== 3 || this.logisticsType === null) return;

      let freight = 0;
      if (
        res.logisticsFreightMap &&
        res.logisticsFreightMap[this.logisticsType] !== undefined
      ) {
        freight = res.logisticsFreightMap[this.logisticsType];
      } else {
        freight = res.freight || 0;
      }

      let totalPrice = 0;
      if (
        res.logisticsTotalPriceMap &&
        res.logisticsTotalPriceMap[this.logisticsType] !== undefined
      ) {
        totalPrice = res.logisticsTotalPriceMap[this.logisticsType];
      } else {
        totalPrice = res.totalPrice || 0;
      }

      const updatedPreCheckout = {
        ...res,
        freight,
        totalPrice
      };
      this.$store.commit("cart/SET_PRECHECKOUT", updatedPreCheckout);
    },
    // 切换配送类型
    changeLogisticsType(type) {
      if (this.logisticsType === type) return;
      this.logisticsType = type;
      sessionStorage.setItem("pur-logisticsType", type);
      this.address.id = null;
      this.refreshPreCheckout();
    },
    // 切换支付方式
    changePayType(type) {
      if (this.payType === type) return;
      this.payType = type;
      sessionStorage.setItem("pur-payType", type);
    },
    // 刷新拉取预下单信息
    refreshPreCheckout() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true
      });
      const params = this.getPreCheckoutParams();
      this.$store
        .dispatch("cart/preCheckout", { params })
        .then(res => {
          this.$toast.clear();

          // 重新根据最新可用列表校准配送和支付模式
          let currentLogistics = this.logisticsType;
          let list = res.logisticsTypeList || [];
          if (currentLogistics !== null && !list.includes(currentLogistics)) {
            currentLogistics =
              res.deliveryMode !== undefined
                ? res.deliveryMode
                : list.length > 0
                ? list[0]
                : null;
            this.logisticsType = currentLogistics;
          }
          if (this.logisticsType !== null) {
            sessionStorage.setItem("pur-logisticsType", this.logisticsType);
          }

          let currentPay = this.payType;
          let payList = res.payModeList || [];
          if (
            currentPay !== null &&
            payList.length > 0 &&
            !payList.includes(currentPay)
          ) {
            currentPay = payList[0];
            this.payType = currentPay;
          }
          sessionStorage.setItem("pur-payType", this.payType);

          this.syncAddress(res);
          if (this.$appSource === 3 && res && res.valueAddedServices) {
            this.selectedServiceIds = res.valueAddedServices
              .filter(e => e.selected)
              .map(e => e.id);
          }
          this.updateVuexPrice(res);
        })
        .catch(() => {
          this.$toast.clear();
        });
    },
    contactService() {
      const serviceContact = this.preCheckout.serviceContact || "";
      if (!serviceContact) return;
      this.$dialog
        .confirm({
          title: "联系客服",
          message: serviceContact,
          confirmButtonText: "拨打",
          confirmButtonColor: "#DD9132"
        })
        .then(() => {
          window.location.href = "tel:" + serviceContact;
        })
        .catch(() => {});
    },
    getLogisticsTypeName(type) {
      const names = {
        0: "门店自提",
        1: "配送",
        2: "直邮"
      };
      return names[type] || "其它";
    },

    // 提交订单触发
    submitBtn() {
      // 1. 校验配送是否允许 (isAllow === 0 表示不允许，但如果自提模式 logisticsType === 0 就不受此限制，因为自提不校验收货地址)
      if (this.preCheckout.orderType !== 2) {
        let needCheckAddress = true;
        if (this.$appSource === 3 && this.logisticsType === 0) {
          needCheckAddress = false;
        }

        if (needCheckAddress) {
          // 校验地址是否被允许
          if (this.preCheckout.isAllow === 0) {
            this.$toast(
              this.preCheckout.addressConstant || "当前地址不可配送，请重新选择"
            );
            return;
          }
        }
      }

      // 2. 校验运费异常
      if (this.preCheckout.freightError) {
        this.showFreightPopup = true;
        return;
      }

      // 3. 全球购实名认证条件：仅直邮(2)且接口要求实名时需要
      let needRealName = this.preCheckout.isRequiredRealName;
      if (this.$appSource === 3) {
        needRealName =
          this.preCheckout.isRequiredRealName && this.logisticsType === 2;
      }

      if (needRealName) {
        this.showIdSheet = true;
      } else {
        this.checkOrder();
      }
    },
    closeSheet() {
      this.showIdSheet = false;
    },
    goAddressList() {
      this.$router.push({
        path: "/mine/addresslist",
        query: {
          previousPage: "pur",
          deliveryMode: this.logisticsType
        }
      });
    },
    inputName(name) {
      this.idName = name;
    },
    inputId(idNum) {
      this.idCard = idNum;
    },
    // 下单提交具体动作
    checkOrder(haveCheckDsCertTip = false) {
      if (this.preCheckout.isDsCertTip === 1 && !haveCheckDsCertTip) {
        this.$dialog
          .confirm({
            message:
              "您的账号还未通过店铺认证，现在下单可能会影响您的订单收益，请先在APP上完成认证流程再下单。",
            confirmButtonText: "确定下单",
            cancelButtonText: "我再想想"
          })
          .then(() => {
            this.checkOrder(true);
          })
          .catch(() => {});
        return;
      }

      let params = {};
      if (parseInt(this.$route.query.buyNow) !== 1) {
        params = {
          idList: JSON.parse(this.$route.query.idList),
          buyNow: parseInt(this.$route.query.buyNow),
          userMessage: localStorage.getItem("pur-note") || "",
          slug: this.slug
        };
      } else {
        let giftCarts = [];
        if (this.$route.query.giftCarts) {
          try {
            giftCarts =
              typeof this.$route.query.giftCarts === "string"
                ? JSON.parse(this.$route.query.giftCarts)
                : this.$route.query.giftCarts;
          } catch (e) {
            giftCarts = [];
          }
        }

        const itemParam = {
          spuId: parseInt(this.$route.query.spuId),
          skuId: parseInt(this.$route.query.skuId),
          amount: parseInt(this.$route.query.amount)
        };

        if (giftCarts && giftCarts.length > 0) {
          itemParam.giftCarts = giftCarts;
        }

        const itemList = this.preCheckout.itemList || [];
        const matchedItem = itemList.find(
          cartItem =>
            cartItem.skuId === itemParam.skuId &&
            cartItem.spuId === itemParam.spuId
        );
        if (matchedItem) {
          itemParam.couponId = matchedItem.couponId;
          itemParam.flashSaleActivityId = matchedItem.flashSaleActivityId;
        }

        const buyFreeId =
          this.$route.query.buyFreeId ||
          (matchedItem && matchedItem.buyFreeId) ||
          (itemList[0] && itemList[0].buyFreeId) ||
          "";

        if (buyFreeId) {
          itemParam.buyFreeId = buyFreeId;
        }

        params = {
          item: itemParam,
          buyNow: parseInt(this.$route.query.buyNow),
          userMessage: localStorage.getItem("pur-note") || "",
          slug: this.slug
        };
      }

      // 地址/自提点必填条件校验与赋值
      if (this.preCheckout.orderType !== 2) {
        let needCheckAddress = true;
        if (this.$appSource === 3 && this.logisticsType === 0) {
          needCheckAddress = false;
        }

        if (needCheckAddress) {
          if (!this.address || !this.address.id) {
            this.$toast("请先选择收货地址");
            return;
          }
          params.addressId = this.address.id;
        } else {
          // 自提模式校验
          if (
            !this.preCheckout.pickupAddress ||
            !this.preCheckout.pickupAddress.id
          ) {
            this.$toast("暂无可用自提门店");
            return;
          }
          params.pickupId = this.preCheckout.pickupAddress.id;
          params.pickupType = 1;
          params.addressId = "";
        }
      } else {
        params.addressId = "";
      }

      // 全球购实名与订单模式特有参数合并
      if (this.$appSource === 3) {
        params.payType = this.payType;
        params.deliveryMode = this.logisticsType;
        params.pickupType = 1;
        if (this.logisticsType == 0) {
          params.pickupId = this.preCheckout.pickupAddress.id;
        }
        if (this.selectedServiceIds && this.selectedServiceIds.length > 0) {
          params.selectedServiceIds = this.selectedServiceIds;
        }
      }

      if (
        this.preCheckout.isRequiredRealName &&
        (this.$appSource !== 3 || this.logisticsType === 2)
      ) {
        params.buyerIdcardName = this.idName;
        params.buyerIdcardNo = this.idCard;
      }

      if (
        this.preCheckout.kind !== undefined &&
        this.preCheckout.kind !== null
      ) {
        params.kind = this.preCheckout.kind;
      }

      if (this.preCheckout.orderType === 1) {
        params.deliveryPlanTime =
          localStorage.getItem("mall-wap-pur-choosedate") ||
          this.preCheckout.deliveryPlanTime;
      }

      this.$store
        .dispatch("cart/checkout", { params })
        .then(res => {
          this.$router.replace({
            path: "/order/orderpay",
            query: {
              orderSn: res.orderSn
            }
          });
          localStorage.removeItem("pur-note");
          localStorage.removeItem("pur-address");
          localStorage.removeItem("mall-wap-pur-choosedate");
          sessionStorage.removeItem("pur-logisticsType");
          sessionStorage.removeItem("pur-payType");
        })
        .catch(() => {});
    },
    sure() {
      let needRealName = this.preCheckout.isRequiredRealName;
      if (this.$appSource === 3) {
        needRealName =
          this.preCheckout.isRequiredRealName && this.logisticsType === 2;
      }

      if (needRealName) {
        if (!this.idName && !this.preCheckout.idcardName) {
          this.$toast("请输入实名姓名");
          return;
        }
        if (!this.idCard && !this.preCheckout.idcardNo) {
          this.$toast("请输入实名身份证号");
          return;
        }
        const paramsID = {
          idcardName: this.idName || this.preCheckout.idcardName,
          idcardNo: this.idCard || this.preCheckout.idcardNo
        };
        this.$store
          .dispatch("cart/checkIdentityIdcard", { params: paramsID })
          .then(() => {
            this.checkOrder();
          })
          .catch(() => {
            this.$toast("请输入正确的信息");
          });
      } else {
        this.checkOrder();
      }
    },
    goChooseDate(deliveryPlanTime, startDate) {
      this.$router.push({
        path: "/order/choosedate",
        query: {
          deliveryPlanTime: this.preCheckout.currentAvailableTime,
          totalPeriods: this.preCheckout.totalPeriods,
          periodInterval: this.preCheckout.periodInterval,
          purPage: "pur",
          defaultPlanTime: startDate
        }
      });
    },
    goExplain() {
      if (this.preCheckout.orderType === 1) {
        this.$router.push("/order/milkexplaintime");
      } else {
        this.$router.push("/order/explaintime");
      }
    },
    goNote() {
      this.$router.push({
        path: "/mine/cardnote",
        query: {
          purPage: "pur"
        }
      });
    },
    goOrder1() {
      this.$router.push("/agreement/order1");
    },
    openServicePopup() {
      if (this.preCheckout.valueAddedServices && this.preCheckout.valueAddedServices.length > 0) {
        this.tempSelectedServiceIds = [...this.selectedServiceIds];
        this.showServicePopup = true;
      }
    },
    toggleServiceTag(item) {
      if (item.required) return;
      const idx = this.tempSelectedServiceIds.indexOf(item.id);
      if (idx > -1) {
        this.tempSelectedServiceIds.splice(idx, 1);
      } else {
        this.tempSelectedServiceIds.push(item.id);
      }
    },
    confirmSelectedServices() {
      this.selectedServiceIds = [...this.tempSelectedServiceIds];
      this.showServicePopup = false;
      this.refreshPreCheckout();
    }
  }
};
</script>

<style lang="less" scoped>
.purchase_con {
  .title_right {
    width: 36px;
  }
  .product_con_det {
    border-radius: 8px;
    background: #fff;
    margin: 12px 0 0;
    .product_pad {
      padding-bottom: 9px;
      background: #fff;
    }
    .pad_mr {
      margin-top: 10px;
    }
  }
  .free_product_list {
    background: #fff;
    padding: 0 12px 12px;
    .free_pad {
      padding: 0 20px;
    }
  }
  .bao_name {
    padding: 4px 12px;
  }
  .det_all {
    margin: 12px 0 0;
  }
  .bottom_margin {
    height: 60px;
  }
  .det_color {
    color: rgba(191, 146, 100, 1);
  }
  .pro_padd {
    padding-bottom: 12px;
  }
  .freight_popup {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #fff;
    .freight_header {
      height: 56px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      .freight_title {
        font-size: 14px;
        font-weight: 500;
        color: rgba(34, 34, 34, 0.87);
      }
      .close_icon {
        position: absolute;
        right: 15px;
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }
    .warning_bar {
      padding: 8px 12px;
      background: #fffbe6;
      border-bottom: 1px solid #ffe58f;
      color: rgba(0, 0, 0, 0.65);
      font-size: 12px;
      text-align: left;
    }
    .freight_list {
      flex: 1;
      overflow-y: auto;
      padding: 12px;
      .freight_cell {
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 4px;
        background: #fff;
        padding: 12px;
        margin-bottom: 12px;
        .cell_header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          font-size: 12px;
          .store_name {
            font-size: 14px;
            font-weight: 500;
            color: rgba(34, 34, 34, 0.85);
          }
          .price_info {
            color: rgba(0, 0, 0, 0.45);
          }
        }
        .cell_divider {
          height: 1px;
          background-color: rgba(0, 0, 0, 0.08);
          margin: 8px 0;
        }
        .goods_grid {
          display: flex;
          flex-wrap: wrap;
          .goods_img_box {
            width: 60px;
            height: 60px;
            margin-right: 8px;
            margin-bottom: 8px;
            border: 1px solid rgba(0, 0, 0, 0.05);
            border-radius: 2px;
            overflow: hidden;
            .goods_img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }
    .freight_btn_container {
      padding: 12px;
      box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
      .sure_btn {
        height: 42px;
        line-height: 42px;
        background: #bf9264;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        border-radius: 4px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}

.service_popup_box {
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  padding: 15px;
  text-align: left;
  .service_popup_title {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    text-align: center;
    margin-bottom: 20px;
    margin-top: 5px;
  }
  .service_popup_content {
    flex: 1;
    overflow-y: auto;
    .service_tags_container {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      padding: 10px 0;
      .service_tag {
        font-size: 12px;
        color: #333;
        background-color: #f7f7f7;
        border: 1px solid #e0e0e0;
        border-radius: 15px;
        padding: 5px 14px;
        transition: all 0.2s ease;
      }
      .service_tag_selected {
        color: #fff;
        background-color: #bf9264;
        border-color: #bf9264;
      }
    }
  }
  .service_popup_footer {
    margin-top: 15px;
    .confirm_btn {
      height: 44px;
      line-height: 44px;
      background-color: #bf9264;
      color: #fff;
      text-align: center;
      border-radius: 22px;
      font-size: 15px;
      font-weight: 500;
      cursor: pointer;
    }
  }
}
</style>
